var _path, _path2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLinkIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.66667 11.3333C6.66667 11.7333 6.4 12 6 12H4C1.8 12 0 10.2 0 8C0 5.8 1.8 4 4 4H6C6.4 4 6.66667 4.26667 6.66667 4.66667C6.66667 5.06667 6.4 5.33333 6 5.33333H4C2.53333 5.33333 1.33333 6.53333 1.33333 8C1.33333 9.46667 2.53333 10.6667 4 10.6667H6C6.4 10.6667 6.66667 10.9333 6.66667 11.3333ZM12 4H10C9.6 4 9.33333 4.26667 9.33333 4.66667C9.33333 5.06667 9.6 5.33333 10 5.33333H12C13.4667 5.33333 14.6667 6.53333 14.6667 8C14.6667 9.46667 13.4667 10.6667 12 10.6667H10C9.6 10.6667 9.33333 10.9333 9.33333 11.3333C9.33333 11.7333 9.6 12 10 12H12C14.2 12 16 10.2 16 8C16 5.8 14.2 4 12 4ZM5.33333 8.66667C4.93333 8.66667 4.66667 8.4 4.66667 8C4.66667 7.6 4.93333 7.33333 5.33333 7.33333H10.6667C11.0667 7.33333 11.3333 7.6 11.3333 8C11.3333 8.4 11.0667 8.66667 10.6667 8.66667H5.33333Z",
    fill: "#ACB5BD"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_25088_46200",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 4,
    width: 16,
    height: 8
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.66667 11.3333C6.66667 11.7333 6.4 12 6 12H4C1.8 12 0 10.2 0 8C0 5.8 1.8 4 4 4H6C6.4 4 6.66667 4.26667 6.66667 4.66667C6.66667 5.06667 6.4 5.33333 6 5.33333H4C2.53333 5.33333 1.33333 6.53333 1.33333 8C1.33333 9.46667 2.53333 10.6667 4 10.6667H6C6.4 10.6667 6.66667 10.9333 6.66667 11.3333ZM12 4H10C9.6 4 9.33333 4.26667 9.33333 4.66667C9.33333 5.06667 9.6 5.33333 10 5.33333H12C13.4667 5.33333 14.6667 6.53333 14.6667 8C14.6667 9.46667 13.4667 10.6667 12 10.6667H10C9.6 10.6667 9.33333 10.9333 9.33333 11.3333C9.33333 11.7333 9.6 12 10 12H12C14.2 12 16 10.2 16 8C16 5.8 14.2 4 12 4ZM5.33333 8.66667C4.93333 8.66667 4.66667 8.4 4.66667 8C4.66667 7.6 4.93333 7.33333 5.33333 7.33333H10.6667C11.0667 7.33333 11.3333 7.6 11.3333 8C11.3333 8.4 11.0667 8.66667 10.6667 8.66667H5.33333Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_25088_46200)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0H16V16H0V0Z",
    fill: "#ACB5BD"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkIcon);
export default __webpack_public_path__ + "static/media/LinkIcon.e2fee9812e1dc201468d3ba7e061739f.svg";
export { ForwardRef as ReactComponent };